export var sortByText = {
  keys: ['text']
};
export var noSort = {
  sorter: rankedItems => rankedItems
};
//# sourceMappingURL=sortRules.js.map